import React from 'react';
import { useNavigate } from 'react-router-dom';

function LandingPage() {
  const navigate = useNavigate();

  const handleLogin = (type) => {
    switch (type) {
      case 'paas':
        navigate('/paas-admin/login');
        break;
      case 'saas':
        navigate('/saas-admin/login');
        break;
      case 'client':
        navigate('/client-admin/login');
        break;
      case 'app':
        navigate('/login');
        break;
      default:
        navigate('/login');
    }
  };

  return (
    <div style={styles.container}>
      <div style={styles.heroSection}>
        <h1 style={styles.title}>Welcome to MultiPaaS</h1>
        <p style={styles.subtitle}>Scalable microservices platform for your business</p>
        
        <div style={styles.loginOptions}>
          <h2 style={styles.sectionTitle}>Choose Your Portal</h2>
          
          <div style={styles.cardGrid}>
            <div style={styles.card}>
              <h3 style={styles.cardTitle}>PAAS Admin</h3>
              <p style={styles.cardDesc}>Platform as a Service administration</p>
              <button 
                style={styles.loginButton} 
                onClick={() => handleLogin('paas')}
              >
                Login as PAAS Admin
              </button>
            </div>
            
            <div style={styles.card}>
              <h3 style={styles.cardTitle}>SaaS Admin</h3>
              <p style={styles.cardDesc}>Software as a Service administration</p>
              <button 
                style={styles.loginButton} 
                onClick={() => handleLogin('saas')}
              >
                Login as SaaS Admin
              </button>
            </div>
            
            <div style={styles.card}>
              <h3 style={styles.cardTitle}>Client Admin</h3>
              <p style={styles.cardDesc}>Client administration portal</p>
              <button 
                style={styles.loginButton} 
                onClick={() => handleLogin('client')}
              >
                Login as Client Admin
              </button>
            </div>
            
            <div style={styles.card}>
              <h3 style={styles.cardTitle}>User</h3>
              <p style={styles.cardDesc}>End user login</p>
              <button 
                style={styles.loginButton} 
                onClick={() => handleLogin('app')}
              >
                Login as User
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

const styles = {
  container: {
    minHeight: '100vh',
    background: 'linear-gradient(135deg, #0f172a 0%, #1e3a5f 100%)',
    color: 'white',
    padding: '40px 20px'
  },
  heroSection: {
    maxWidth: '1200px',
    margin: '0 auto',
    textAlign: 'center'
  },
  title: {
    fontSize: '48px',
    fontWeight: 'bold',
    marginBottom: '16px'
  },
  subtitle: {
    fontSize: '20px',
    opacity: 0.9,
    marginBottom: '48px'
  },
  loginOptions: {
    marginTop: '40px'
  },
  sectionTitle: {
    fontSize: '28px',
    marginBottom: '32px'
  },
  cardGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
    gap: '24px',
    marginTop: '32px'
  },
  card: {
    background: 'rgba(255,255,255,0.1)',
    borderRadius: '12px',
    padding: '32px',
    textAlign: 'center',
    transition: 'transform 0.2s'
  },
  cardTitle: {
    fontSize: '24px',
    marginBottom: '12px'
  },
  cardDesc: {
    fontSize: '14px',
    opacity: 0.8,
    marginBottom: '24px'
  },
  loginButton: {
    background: 'linear-gradient(135deg, #4a90d9 0%, #22c55e 100%)',
    color: 'white',
    border: 'none',
    padding: '12px 24px',
    borderRadius: '8px',
    fontSize: '16px',
    cursor: 'pointer',
    fontWeight: '500',
    transition: 'opacity 0.2s'
  }
};

export default LandingPage;